/**
 * Implements Subscription Page
 */
import AdblockChecker from '../../components/AdblockModal';
import Modal from '../../components/Modal';
import Notifs from '../../components/Notifications';
import TickersDisplayBar from '../../components/TickersDisplayBar';
import Header from '../MainPage/Header';
import SubscriptionBody from './SubscriptionBody';

import './styles.scss';

const SubscriptionPage = () => {
  return (
    <div className='main_page' style={{ overflowX: 'hidden' }}>
      <TickersDisplayBar />
      <Header />
      <SubscriptionBody />
      <Modal />
      <Notifs />
      <AdblockChecker />
    </div>
  );
};

export default SubscriptionPage;
